import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHelp = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zm-.035 10.09c.375 0 .686.28.735.643l.006.101v.321a.743.743 0 0 1-.74.745.743.743 0 0 1-.735-.644l-.007-.101v-.32c0-.412.332-.746.741-.746zm0-8.94C9.603 2.65 11 4.052 11 5.697c0 .597-.258 1.285-.62 1.812a2.06 2.06 0 0 1-.381.407l-.134.107-.478.367c-.466.377-.669.714-.68 1.282a.743.743 0 0 1-.758.728.743.743 0 0 1-.725-.76c.021-.988.395-1.676 1.071-2.274l.215-.179.534-.41a.73.73 0 0 0 .116-.115c.204-.297.357-.706.357-.965 0-.822-.732-1.557-1.552-1.557-.76 0-1.407.626-1.476 1.401l-.006.138a.743.743 0 0 1-.742.745A.743.743 0 0 1 5 5.68C5 4.03 6.332 2.65 7.965 2.65z" />
    </g>
  );
};

export default withIcon(IconHelp);
